export default ({
    root: {
        width: 'auto',
        height: 'auto'
    }
});
